import { useEffect, useState } from 'react';
import { documentService } from '../../../utils/window.utils.js';

const useHasComponentById = (id: string): boolean => {
  const [hasComponentById, setHasComponentById] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setHasComponentById(documentService()?.getElementById?.(id));
  }, []);

  return !!hasComponentById ;
};

export default useHasComponentById;
